import { GetFeatureFlags } from "connection/feature-flags";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setFeatureFlags } from "store/actions/feature-flags";

// ensures that feature flags are ready before attempting to render the admin side of the app
const FeatureFlagGate = ({ children }: { children: React.ReactNode }) => {
	const dispatch = useDispatch();
	const [retries, setRetries] = useState(0);

	const fetchFeatureFlags = useCallback(async () => {
		try {
			const flags = await GetFeatureFlags();
			dispatch(setFeatureFlags(flags));
		} catch (e) {
			console.error(e);
			setTimeout(() => setRetries(prev => prev + 1), 1000);
		}
	}, [dispatch]);

	useEffect(() => {
		fetchFeatureFlags();
	}, [fetchFeatureFlags, retries]);

	return <>{children}</>;
};

export default FeatureFlagGate;
